import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import {
	type ISSUE_RESTRICTION_GQL_FIELD,
	ISSUE_RESTRICTION_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { AggTransformerFunction } from '../types/transformer-type.tsx';
import {
	transformAggConnection,
	transformAggNodeToLegacyField,
} from './default-node-transformer.tsx';

export type Restriction = {
	restrictionValue: string;
};

const transformJiraRoleToRestriction = (role: {
	readonly id: string;
	readonly roleId: string;
}): Restriction | null => {
	if (role == null) return null;
	return { restrictionValue: role.roleId };
};

export const transformAggIssueRestrictionToLegacyField: AggTransformerFunction<
	typeof ISSUE_RESTRICTION_GQL_FIELD
> = (node, projectContext) => {
	if (node.type !== ISSUE_RESTRICTION_TYPE) return undefined;

	const roles = transformAggConnection(
		node.selectedRolesConnection,
		transformJiraRoleToRestriction,
	);

	const restrictions = roles.length > 0 ? { projectrole: roles } : {};

	return {
		...transformAggNodeToLegacyField(node),
		value: {
			shouldDisplay: projectContext?.canSetIssueRestriction === true,
			issuerestrictions: restrictions,
		},
		schema: {
			configuration: null,
			items: null,
			renderer: PLAIN_TEXT,
			type: ISSUE_RESTRICTION_TYPE,
			custom: null,
			system: node.type,
		},
	};
};
